<div id="timeline-container" #timelineContainer>
  <div id="above-timeline-container">
    <!-- Congress divider + toggle (new top divider) -->
    <div class="section-divider" [class.collapsed]="!congressRowVisible">
      <div class="section-toggle" (click)="toggleCongressRow()">
        <rds-icon [icon]="congressRowVisible ? 'chevron_down' : 'chevron_right'" namespace="outlined"></rds-icon>
        <span class="toggle-label">Congresses</span>
      </div>
      <div class="divider-line"></div>
    </div>

    <!-- Congress row -->
    <div id="congress-row" class="above-timeline-row" [class.collapsed]="!congressRowVisible">
      @if (congressRowVisible) {
        <span class="row-header">Congresses</span>
        <div class="row-content data-column">
          @for (congress of congressRow; track congress) {
            <app-timestamp [data]="congress.data" [type]="congress.type" [month]="congress.date"></app-timestamp>
          }
        </div>
      }
    </div>

    @if (features.isEntityTypeEnabled('milestones')) {
      <!-- Milestone divider + toggle (existing divider between congress & milestones) -->
      <div class="section-divider" [class.collapsed]="!milestoneRowVisible"
           [class.draggable]="congressRowVisible && milestoneRowVisible"
           (mousedown)="congressRowVisible && milestoneRowVisible && interRowHandleClick($event)"
           (touchstart)="congressRowVisible && milestoneRowVisible && interRowHandleClick($event)">
        <div class="section-toggle" (click)="toggleMilestoneRow(); $event.stopPropagation()">
          <rds-icon [icon]="milestoneRowVisible ? 'chevron_down' : 'chevron_right'" namespace="outlined"></rds-icon>
          <span class="toggle-label">Milestones</span>
        </div>
        <div class="divider-line" id="inter-row-drag-indicator"></div>
      </div>

      <!-- Milestone row -->
      <div id="milestone-row" class="above-timeline-row" [class.collapsed]="!milestoneRowVisible">
        @if (milestoneRowVisible) {
          <span class="row-header">Milestones</span>
          <div class="row-content data-column">
            @for (milestone of milestoneRow; track milestone) {
              <app-timestamp [data]="milestone.data" [type]="milestone.type" [month]="milestone.date"></app-timestamp>
            }
          </div>
        }
      </div>
    }

  </div>

  <rds-timeline align="end" orientation="horizontal">
    @for (timestamp of timelineTexts; track timestamp) {
      <rds-timeline-event [event]="{status: 'default'}">
        <p class="month" [id]="timestamp.id">
          {{ timestamp.text }}
        </p>
      </rds-timeline-event>
    }
  </rds-timeline>
  <div id="below-timeline-container">
    <!-- Publication divider + toggle -->
    <div class="section-divider" [class.collapsed]="!publicationRowVisible">
      <div class="section-toggle" (click)="togglePublicationRow()">
        <rds-icon [icon]="publicationRowVisible ? 'chevron_down' : 'chevron_right'" namespace="outlined"></rds-icon>
        <span class="toggle-label">Publications</span>
      </div>
      <div class="divider-line"></div>
    </div>

    <!-- Publication row -->
    <div id="publication-row" class="below-timeline-row" [class.collapsed]="!publicationRowVisible">
      @if (publicationRowVisible) {
        <span class="row-header">Publications</span>
        <div class="row-content data-column">
          @for (publication of publicationRow; track publication) {
            <app-timestamp [data]="publication.data" [type]="publication.type" [month]="publication.date"></app-timestamp>
          }
        </div>
      }
    </div>

    @if (features.isEnabled('customActivities')) {
      <!-- Activity divider + toggle (existing divider between publications & activities) -->
      <div class="section-divider" [class.collapsed]="!activityRowVisible"
           id="pub-act-divider"
           [class.draggable]="publicationRowVisible && activityRowVisible"
           (mousedown)="publicationRowVisible && activityRowVisible && belowRowHandleClick($event, 'publication-row', 'activity-row')"
           (touchstart)="publicationRowVisible && activityRowVisible && belowRowHandleClick($event, 'publication-row', 'activity-row')">
        <div class="section-toggle" (click)="toggleActivityRow(); $event.stopPropagation()">
          <rds-icon [icon]="activityRowVisible ? 'chevron_down' : 'chevron_right'" namespace="outlined"></rds-icon>
          <span class="toggle-label">Activities</span>
        </div>
        <div class="divider-line inter-row-drag-indicator"></div>
      </div>

      <!-- Activity row -->
      <div id="activity-row" class="below-timeline-row" [class.collapsed]="!activityRowVisible">
        @if (activityRowVisible) {
          <span class="row-header">Activities</span>
          <div class="row-content data-column">
            @for (activity of activityRow; track activity) {
              <app-timestamp [data]="activity.data" [type]="activity.type" [month]="activity.date"></app-timestamp>
            }
          </div>
        }
      </div>
    }

    @if (features.isEnabled('vvpmActivities')) {
      <!-- Material divider + toggle (existing divider between activities & materials) -->
      <div class="section-divider" [class.collapsed]="!materialRowVisible"
           id="act-mat-divider"
           [class.draggable]="activityRowVisible && materialRowVisible"
           (mousedown)="activityRowVisible && materialRowVisible && belowRowHandleClick($event, 'activity-row', 'material-row')"
           (touchstart)="activityRowVisible && materialRowVisible && belowRowHandleClick($event, 'activity-row', 'material-row')">
        <div class="section-toggle" (click)="toggleMaterialRow(); $event.stopPropagation()">
          <rds-icon [icon]="materialRowVisible ? 'chevron_down' : 'chevron_right'" namespace="outlined"></rds-icon>
          <span class="toggle-label">Materials</span>
        </div>
        <div class="divider-line inter-row-drag-indicator"></div>
      </div>

      <!-- Material row -->
      <div id="material-row" class="below-timeline-row" [class.collapsed]="!materialRowVisible">
        @if (materialRowVisible) {
          <span class="row-header">Materials</span>
          <div class="row-content data-column">
            @for (material of materialRow; track material) {
              <app-timestamp [data]="material.data" [type]="material.type" [month]="material.date"></app-timestamp>
            }
          </div>
        }
      </div>
    }
  </div>
  <div id="zoom">
    <app-zoom-control (zoomChange)="onZoomChange($event)"></app-zoom-control>
  </div>

  <div #splitScreenControl id="split-screen-control" class="container"
       (mousedown)="splitScreenHandleClick($event)"
        (touchstart)="splitScreenHandleClick($event)">
    <div id="drag-handle"></div>
    <button rds-icon-button id="split-screen-reset" size="m" (click)="resetSplitScreenDistribution()">
      <rds-icon icon="undo" namespace="outlined"></rds-icon>
    </button>
  </div>
</div>
